module.exports = __webpack_public_path__ + "static/lang_audio@2x-877a76bc42c1666ab77eddbf21a8daab.png";